if (!customElements.get('card-color-swatches')) {
  customElements.define(
    'card-color-swatches',
    class CardColorSwatches extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.onSwatchClick.bind(this));
      }

      onSwatchClick(event) {
        const swatch = event.target.closest('.card-color-swatches__swatch');
        if (!swatch || !this.contains(swatch)) return;
        event.preventDefault();
        if (swatch.getAttribute('aria-selected') === 'true') return;
        this.select(swatch);
      }

      /*
       * Same behavior as TablistProduct (global.js) but across the sibling
       * products of a color group: toggles the pre-rendered image tabpanel and
       * syncs title, color name, prices and quick-add form.
       */
      select(swatch) {
        const card = this.closest('.card-wrapper') || this.closest('.card');
        if (!card) return;

        this.querySelectorAll('.card-color-swatches__swatch').forEach((tab) => {
          const isSelected = tab === swatch;
          tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          tab.classList.toggle('card-color-swatches__swatch--active', isSelected);
          // Panel ids can be duplicated across hidden renders of the same card
          // (predictive search, header menus) — resolve within this card only.
          const panelId = tab.getAttribute('aria-controls');
          const panel = panelId && card.querySelector(`#${CSS.escape(panelId)}`);
          if (panel) {
            panel.classList.toggle('hidden', !isSelected);
            panel.setAttribute('aria-hidden', isSelected ? 'false' : 'true');
          }
        });

        const { url, title, colorLabel, variantId, variantTitle, variantPrice, productForm } = swatch.dataset;

        const link = card.querySelector('.card__heading a');
        if (link) {
          if (url) link.setAttribute('href', url);
          if (title) link.textContent = title;
        }

        // The color name line is dropped when the card subtitle already carries it
        // (product type = color name), so fall back to the subtitle itself.
        const colorName = card.querySelector('.card-color-swatches__name') || card.querySelector('.card__subtitle');
        if (colorName && colorLabel) colorName.textContent = colorLabel;

        const variantName = card.querySelector('.card-color-swatches__variant');
        if (variantName && variantTitle) variantName.textContent = variantTitle;

        if (productForm && variantId) {
          const productFormElement = card.querySelector(`#${CSS.escape(productForm)}`) || document.getElementById(productForm);
          const idInput = productFormElement && productFormElement.querySelector('[name="id"]');
          if (idInput) idInput.value = variantId;
        }

        if (variantPrice) {
          const quickAddPrice = card.querySelector('.quick-add-price');
          if (quickAddPrice) quickAddPrice.innerHTML = variantPrice;
          const priceItem = card.querySelector('.price .price-item--regular');
          if (priceItem) priceItem.textContent = variantPrice;
        }
      }
    }
  );
}
